import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { type Edge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	dropIndicator: {
		height: '2px',
		width: '32px',
		position: 'absolute',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
	dropIndicatorTop: {
		top: token('space.negative.075'),
	},
	dropIndicatorBottom: {
		bottom: token('space.negative.075'),
	},
});

/**
 * A visual indicator that shows the closest edge of the drop target.
 */
export const DropIndicator = ({
	testId,
	closestEdge,
}: {
	closestEdge: Edge;
	testId: string;
}): React.JSX.Element => {
	return (
		<Box
			xcss={cx(
				styles.dropIndicator,
				closestEdge === 'top' ? styles.dropIndicatorTop : styles.dropIndicatorBottom,
			)}
			backgroundColor="color.background.accent.blue.bolder"
			testId={testId}
		/>
	);
};
